import { render, staticRenderFns } from "./SkeletonResponse.vue?vue&type=template&id=ce63797a&scoped=true&"
import script from "./SkeletonResponse.vue?vue&type=script&lang=js&"
export * from "./SkeletonResponse.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonResponse.vue?vue&type=style&index=0&id=ce63797a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce63797a",
  null
  
)

export default component.exports
import {QItemSection,QSkeleton,QItemLabel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QItemSection,QSkeleton,QItemLabel})
